import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-bon-liv-negoce',
  templateUrl: './brouillon-bon-liv-negoce.component.html',
  styleUrls: ['./brouillon-bon-liv-negoce.component.scss']
})
export class BrouillonBonLivNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
